import { render, staticRenderFns } from "./JobOrderDetails.vue?vue&type=template&id=6a4a9330&"
import script from "./JobOrderDetails.vue?vue&type=script&lang=js&"
export * from "./JobOrderDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports